// Chakra Imports
import {Box, Flex, useColorModeValue} from '@chakra-ui/react';
import React, {useEffect, useState} from 'react';
import AdminNavbarLinks from 'components/navbar/NavbarLinks.js';
import {useLocation} from "react-router-dom";

export default function AdminNavbar() {
    const [, setScrolled] = useState(false);
    const location = useLocation();
    const currentPath = location.pathname;
    const segments = currentPath.split('/');
    const lastSegment = segments[segments.length - 1] || segments[segments.length - 2]; // handles trailing slash
    let currentPage = lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1);

    useEffect(() => {
        window.addEventListener('scroll', changeNavbar);

        return () => {
            window.removeEventListener('scroll', changeNavbar);
        };
    });

    // Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
    let mainText = useColorModeValue('navy.700', 'white');
    let navbarPosition = 'fixed';
    let navbarFilter = 'none';
    let navbarBackdrop = 'blur(20px)';
    let navbarShadow = 'none';
    let navbarBg = useColorModeValue('rgba(244, 247, 254, 0.2)', 'rgba(11,20,55,0.5)');
    let navbarBorder = 'transparent';
    let secondaryMargin = '0px';
    let paddingX = '15px';
    let gap = '0px';
    const changeNavbar = () => {
        if (window.scrollY > 1) {
            setScrolled(true);
        } else {
            setScrolled(false);
        }
    };

    return (
        <Box
            position={navbarPosition}
            boxShadow={navbarShadow}
            bg={navbarBg}
            borderColor={navbarBorder}
            filter={navbarFilter}
            backdropFilter={navbarBackdrop}
            backgroundPosition='center'
            backgroundSize='cover'
            borderRadius='16px'
            borderWidth='1.5px'
            borderStyle='solid'
            transitionDelay='0s, 0s, 0s, 0s'
            transitionDuration=' 0.25s, 0.25s, 0.25s, 0s'
            transition-property='box-shadow, background-color, filter, border'
            transitionTimingFunction='linear, linear, linear, linear'
            alignItems={{xl: 'center'}}
            display={'flex'}
            minH='75px'
            justifyContent={{xl: 'center'}}
            lineHeight='25.6px'
            mx='auto'
            mt={secondaryMargin}
            pb='8px'
            right={{base: '12px', md: '30px', lg: '30px', xl: '30px'}}
            px={{
                sm: paddingX,
                md: '10px'
            }}
            ps={{
                xl: '12px'
            }}
            pt='8px'
            top={{base: '12px', md: '16px', lg: '20px', xl: '20px'}}
            w={{
                base: 'calc(100vw - 6%)',
                md: 'calc(100vw - 8%)',
                lg: 'calc(100vw - 6%)',
                xl: 'calc(100vw - 350px)',
                '2xl': 'calc(100vw - 365px)'
            }}>
            <Flex
                w='100%'
                flexDirection={{
                    sm: 'column',
                    md: 'row'
                }}
                alignItems={{xl: 'center'}}
                mb={gap}>
                <Box mb={{sm: '8px', md: '0px'}}>
                    {/*<Breadcrumb>*/}
                    {/*	<BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>*/}
                    {/*		<BreadcrumbLink href='#' color={secondaryText}>*/}
                    {/*			Pages*/}
                    {/*		</BreadcrumbLink>*/}
                    {/*	</BreadcrumbItem>*/}

                    {/*	<BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>*/}
                    {/*		<BreadcrumbLink href='#' color={secondaryText}>*/}
                    {/*			{brandText}*/}
                    {/*		</BreadcrumbLink>*/}
                    {/*	</BreadcrumbItem>*/}
                    {/*</Breadcrumb>*/}
                    {/* Here we create navbar brand, based on route name */}
                    <Box
                        color={mainText}
                        bg='inherit'
                        borderRadius='inherit'
                        fontWeight='bold'
                        fontSize='34px'
                    >
                        {currentPage}
                    </Box>
                </Box>
                <Box ms='auto' w={{sm: '100%', md: 'unset'}}>
                    <AdminNavbarLinks/>
                </Box>
            </Flex>
        </Box>
    );
}
